import { render, staticRenderFns } from "./RepairDetail.vue?vue&type=template&id=6caec4a4&"
import script from "./RepairDetail.vue?vue&type=script&lang=js&"
export * from "./RepairDetail.vue?vue&type=script&lang=js&"
import style0 from "./RepairDetail.vue?vue&type=style&index=0&id=6caec4a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports